import { Col } from '@opendoor/atoms/box';
import type { MarketplaceProperty } from 'components/marketplace/property/types';
import { Pill } from 'components/marketplace/shared/Pill';

type PropertyStatusData = Pick<MarketplaceProperty, 'displayBadge' | 'listingState'>;
type PropertyStatus = PropertyStatusData['displayBadge'] | PropertyStatusData['listingState'];

interface PropertyStatusProps {
  property: PropertyStatusData;
}

// `listingState` omits badge-only states such as TEMP_UNAVAILABLE, so status
// labels fall back to `displayBadge` when needed.
const DisplayStateStatusMap = {
  TEMP_UNAVAILABLE: 'Temporarily unavailable',
  AVAILABLE_SOON: 'Available soon',
  IN_CONTRACT: 'In contract',
  RECENTLY_SOLD: 'Sold',
  ON_THE_MARKET: undefined,
  TRADITIONAL: undefined,
  UNKNOWN: undefined,
} satisfies Record<PropertyStatus, string | undefined>;

const getStatusLabel = (property: PropertyStatusData): string | undefined => {
  if (DisplayStateStatusMap[property.listingState]) {
    return DisplayStateStatusMap[property.listingState];
  }
  if (DisplayStateStatusMap[property.displayBadge]) {
    return DisplayStateStatusMap[property.displayBadge];
  }
  return undefined;
};

export const PropertyStatus = ({ property }: PropertyStatusProps) => {
  const label = getStatusLabel(property);
  if (!label) {
    return null;
  }
  return (
    <Col className="pb-6">
      <Pill label={label} rounded responsive />
    </Col>
  );
};
